export default __webpack_public_path__ + "pgnv-assets/0843f9c456563572981bd2d1a0e1dba0.svg";